import { Link } from 'react-router-dom';
import { ReactComponent as LogoIcon } from 'images/logo.svg';

const Logo = () => {
    return (
        <Link to="/">
            <LogoIcon className="main-logo-icon" />
        </Link>
    );
};

export default Logo;
